/* eslint-disable jsx-a11y/aria-proptypes */
/* eslint-disable prettier/prettier */
'use client';
import LinkWrapper from 'helpers/SitecoreWrappers/LinkWrapper/LinkWrapper';
import { JSX, useRef } from 'react';
import { tv } from 'tailwind-variants';

const LinkBannerToCW = (): JSX.Element | null => {
  const linkRef = useRef<HTMLAnchorElement>(null);
  const href = process.env.NEXT_PUBLIC_URL_BACK_TO_CW;
  if (!href) return null;

  const { linkWrapperClass, linkTextClass } = TailwindVariants();
  const linkText = "Visit Children's Wisconsin";

  return (
    <LinkWrapper
      ref={linkRef}
      field={{
        href,
        title: linkText,
        text: linkText,
        target: '_self',
      }}
      className={linkWrapperClass()}
      aria-label={linkText}
      style={{ cursor: 'default' }}
    >
      <span
        className={linkTextClass()}
        style={{ cursor: 'pointer' }}
      >
        {linkText}
      </span>
    </LinkWrapper>
  );
};

export default LinkBannerToCW;

export const TailwindVariants = tv({
  slots: {
    linkWrapperClass:
      'relative w-full banner-bg-dk-blue text-white py-4 px-10 z-40 flex justify-end items-center',
    linkTextClass: 'text-right px-4 lg:px-0',
  },
});
